module.exports = __webpack_public_path__ + "static/media/hugo-boss-the-scent-big.2aa9b104.png";